declare namespace $ {

	type $shm_hitalama_chart_line__gap_left_shm_hitalama_map_widget_float_chart_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['gap_left'] >
		,
		ReturnType< $shm_hitalama_chart_line['gap_left'] >
	>
	type $shm_hitalama_chart_line__names_shm_hitalama_map_widget_float_chart_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['names'] >
		,
		ReturnType< $shm_hitalama_chart_line['names'] >
	>
	type $shm_hitalama_chart_line__labels_shm_hitalama_map_widget_float_chart_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['labels'] >
		,
		ReturnType< $shm_hitalama_chart_line['labels'] >
	>
	type $shm_hitalama_chart_line__series_y_shm_hitalama_map_widget_float_chart_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['series_y'] >
		,
		ReturnType< $shm_hitalama_chart_line['series_y'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_chart_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_chart_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['settings_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_chart_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_chart_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['filter_name'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_chart_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['filter_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_chart_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['filter_buttons'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_widget_float_chart_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_widget_float_chart_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['Filters_add_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_widget_float_chart_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_chart_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_chart_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart['gap_left'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_chart_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_chart extends $shm_hitalama_map_widget_float {
		names( ): readonly(any)[]
		labels( ): readonly(string)[]
		series_y( id: any): readonly(any)[]
		Chart( ): $shm_hitalama_chart_line
		settings_add( next?: any ): any
		Settings_add( ): $mol_button_minor
		Filters_add_anchor( ): $mol_button_minor
		filter_name( id: any): string
		filter_add( id: any, next?: any ): any
		Filter_add( id: any): $mol_button_minor
		filter_buttons( ): readonly(any)[]
		Filters( ): $mol_list
		Filters_add( ): $mol_pop_over
		Gap_left_label( ): $mol_text
		gap_left( next?: number ): number
		Gap_left( ): $mol_number
		Gap_left_section( ): $mol_view
		controls( ): readonly(any)[]
		width_min( ): number
		height_min( ): number
		contextmenu_body( ): readonly(any)[]
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map